import { render, staticRenderFns } from "./GenerateRBBagReport.vue?vue&type=template&id=2254ac90&scoped=true&"
import script from "./GenerateRBBagReport.vue?vue&type=script&lang=js&"
export * from "./GenerateRBBagReport.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./GenerateRBBagReport.vue?vue&type=style&index=1&id=2254ac90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254ac90",
  null
  
)

export default component.exports